module.exports = __webpack_public_path__ + "img/Video.6e2ae1d0.png";